<div>
  <app-shared-info
    class="hmn-margin__x4-bottom hmn-display__block"
    [label]="'ID'"
    [value]="'un_1287dgbi2f32ffeef'"></app-shared-info>

  <app-shared-info
    class="hmn-margin__x4-bottom hmn-display__block"
    [label]="'name'"
    [value]="'Unit name 1'"></app-shared-info>

  <app-shared-info
    class="hmn-margin__x4-bottom hmn-display__block"
    [label]="'address'"
    [value]="'Via Arnolfo di Cambio'"></app-shared-info>

  <app-shared-info
    class="hmn-margin__x4-bottom hmn-display__block"
    [label]="'city - province'"
    [value]="'MILANO - MI'"></app-shared-info>

  <app-shared-info
    class="hmn-margin__x4-bottom hmn-display__block"
    [label]="'state'"
    [value]="'Lombardia'"></app-shared-info>

  <app-shared-info
    class="hmn-margin__x4-bottom hmn-display__block"
    [label]="'country'"
    [value]="'Italia'"></app-shared-info>

  <app-shared-info
    class="hmn-margin__x4-bottom hmn-display__block"
    [label]="'square meters'"
    [value]="'126 sm'"></app-shared-info>
</div>
